import * as React from "react";
import './instanceLayoutBreadcrumb.css'

interface Props {
    steps: any,
    navigateToInstance: any
}

const InstanceLayoutBreadcrumb = (props: Props) => {

    const buildBreadcrumb = () => {
        if (props.steps.length > 1) {
            return props.steps.map((step, index) => {
                return <li key={index} title={getRelationshipsForTooltip(step ,index)} className={'bd-step'}
                           onClick={() => props.navigateToInstance(step)}>
                    <div><p>{`${step.instanceName} (${step.boName})`}</p></div>
                </li>
            });
        }
    }

    const getRelationshipsForTooltip = (step: any, index: number): string => {
        let tooltipText = '';
        if (index >= 1) {
            if (step.relation) {
                const executor = step.instanceName;
                const affected = props.steps[index - 1].instanceName;
                let action;
                if (step.boId === props.steps[index-1].boId) {
                    if (step.relation.outward !== step.relation.selectedRelationship) {
                        action = step.relation.outward;
                    } else {
                        action = step.relation.inward;
                    }
                } else {
                    if (step.relation.toBoClassInfo.outward) {
                        action = step.relation.inward;
                    } else {
                        action = step.relation.outward;
                    }
                }
                tooltipText += `${executor} ${action} ${affected}.` + '\n';
            }
        }
        return tooltipText;
    }

    return (
        <div id={'crumbs'} className={'bd-wrapper'}>
            <ul className={'bd-container'}>
                {buildBreadcrumb()}
            </ul>
        </div>
    )
}
export default InstanceLayoutBreadcrumb;



// WEBPACK FOOTER //
// ./app/components/bo-core/instanceLayoutEditor/breadcrumbComponent/InstanceLayoutBreadcrumb.tsx